import React from 'react'
import FeaturesSection from '../UAEPageComponents/FeaturesSection'
import { faqsUAEThemeParks, OtherFeaturesDataThemeParks, UAEThemeParkFeatures } from '../../../constants/common'
import HeaderSection from '../UAEPageComponents/HeaderSection'
import styles from '../../../styles/UAEPageComponents.module.css'
import styles2 from '../../../styles/UAEPageComponents.module.css';
import OtherFeatures from '../UAEPageComponents/OtherFeatures'
import OutletTypes from '../UAEPageComponents/OutletTypes'
import NewFaqSection from '@/components/HomeLanding/HomeLandingComponents/NewFaqSection'
import TestimonialSectionUAE from '@/components/HomeLanding/HomeLandingComponents/TestimonialSectionUAE'
import AwardsSection from '@/components/HomeLanding/HomeLandingComponents/AwardsSection'
import BusinessUnlockSectionUAE from '@/components/HomeLanding/HomeLandingComponents/BusinessUnlockSectionUAE'
import ConnectWithUsUAE from '@/components/HomeLanding/HomeLandingComponents/ConnectWithUsUAE'
import BlogsAndVideos from '@/components/HomeLanding/HomeLandingComponents/BlogsAndVideos'
import ContqactSection from '../UAEPageComponents/ContactSection'
import UAEBlogsSection from '@/components/HomeLanding/HomeLandingComponents/UAEBlogsSection'
import { NewDownloadBrochureWonderla, QueueBusterExperienceCentersSection, ThemeParkReviewsSection } from '@/components/qbStrap'
import Image from 'next/image'

const DesktopThemePark = () => {
  const HeaderSectionData = {
    firstTitle: "POS Billing Software",
    secondTitle: "For Amusement Parks",
    description: "Great Amusement parks run on precision, speed and customer satisfaction behind the scenes. QueueBuster’s Amusement Park POS Billing Software is designed to help you manage box office ticketing, F&B counters, ERP integrations,RFID wearables, and VAT compliance, all in one place. ",
    images: {
      bgVector: "/assets/UAERetailPage/bgVector.svg",
      bgwidth: "47rem",
      bgheight: "45rem",
      bgtop: "10%",
      bgleft: "0%",
      bgbottom: "10%",
      bgzindex: "0",
      mainImage: {
        src: "/assets/UAEThemeParks/ThemeParks.webp",
        alt: "QueueBuster for Retail",
        width: "68rem",
        height: "41rem",
        bottom: "0",
        right: "0rem"
      },
      img1: {
        src: "/assets/UAEThemeParks/TicketsSold.svg",
        alt: "Quick Bill",
        width: "13rem",
        height: "6rem",
        bottom: "30rem",
        left: "-5rem"

      },
      img2: {
        src: "/assets/UAEThemeParks/gift.svg",
        alt: "Schedule",
        width: "5rem",
        height: "5rem",
        top: "15%",
        left: "20%",
      },
      img3: {
        src: "/assets/UAEThemeParks/HotAirBalloons.svg",
        alt: "Plane Image",
        width: "16rem",
        height: "16rem",
        top: "5%",
        right: "20rem"
      },
      img4: {
        src: "/assets/UAEThemeParks/discount.svg",
        alt: "Plane Image",
        width: "18rem",
        height: "7rem",
        top: "50%",
        right: "5rem",
        zindex: 10
      },

      strVector1: {
        src: "/assets/UAERetailPage/Vector.svg",
        alt: "Vector 1",
        width: "3rem",
        height: "3rem",
        top: "25%",
        left: "10%"
      },
      strVector2: {
        src: "/assets/UAERetailPage/Vector1.svg",
        alt: "Vector 2",
        width: "3rem",
        height: "3rem",
        top: "18%",
        right: "23%"
      },


    }
  }




  const OutletTypesData = [
    {
      image: "/assets/UAERetailPage/Restaurants.png",
      title: "Restaurants",
      hoverColor: "#F68E1E",
    },
    {
      image: "/assets/UAERetailPage/FoodCourts.png",
      title: "Food Courts",
      hoverColor: "#225590"
    },
    {
      image: "/assets/UAERetailPage/Experience.png",
      title: "VR/AR Experience Centers ",
      hoverColor: "#F68E1E",
    },
    {
      image: "/assets/UAERetailPage/Event&PartyZones.png",
      title: "Event & Party Zones",
      hoverColor: "#225590"
    },
    {
      image: "/assets/UAERetailPage/Entertainment.png",
      title: "Family Entertainment Centers ",
      hoverColor: "#F68E1E",
    },
    {
      image: "/assets/UAERetailPage/Relaxation.png",
      title: "Spa & Relaxation Zone",
      hoverColor: "#225590"
    },
    {
      image: "/assets/UAERetailPage/PlayArea.png",
      title: "Kids Play Area",
      hoverColor: "#F68E1E",
    },


  ]
  return (
    <div style={{ fontFamily: 'GilroyMedium' }}>
      <HeaderSection data={HeaderSectionData} />




      
       <FeaturesSection
        data={UAEThemeParkFeatures.slice(0, Math.ceil(UAEThemeParkFeatures.length / 2))}
        indexOffset={0}
        title={"Features Designed for Seamless Park Operations"}

      />
      <div> <NewDownloadBrochureWonderla /> </div>

      <FeaturesSection
        data={UAEThemeParkFeatures.slice(Math.ceil(UAEThemeParkFeatures.length / 2))}
        indexOffset={Math.ceil(UAEThemeParkFeatures.length / 2)}
      />

      <OtherFeatures
        data={OtherFeaturesDataThemeParks}
        title={<>Other Important Features for <br />Amusement Park Billing Software</>} />


      <div className={styles2.features_section} style={{ maxWidth: '1850px', margin: ' auto ', padding: '7rem 18rem 0 18rem' }}>
        <div className={styles2.titleContainer}>
          <p style={{ margin: 0, padding: 0, fontSize: '1.6rem', fontFamily: 'GilroySemiBold' }}>{"The QueueBuster Experience"}</p>
        </div>
        <QueueBusterExperienceCentersSection />
      </div>

      <OutletTypes
        title={"Parks, Gaming Zones, Arcades and more. We Power It All!"}
        data={OutletTypesData}
      />
      <div style={{ margin: ' 0 8rem' }}><ThemeParkReviewsSection /></div>

      {/* <div><TestimonialSectionUAE /></div> */}
      <div className={styles.resposiveSections}>
        <AwardsSection />
        <div ><BusinessUnlockSectionUAE /></div>
        <div><ConnectWithUsUAE /></div>
      </div>
      <div>  <NewFaqSection FaqTableData={faqsUAEThemeParks} heading={"FAQs for UAE Amusement Park POS Software"} />  </div>

      <div>
        <ContqactSection
          title="Couldn’t Find What You Wanted?"
          description={<>Worry not, just send us your inquiry and <br /> wait while our POS experts contact you.</>}
          buttonText="Request a callback"
        />
      </div>

      <div >
        <UAEBlogsSection />
      </div>
    </div>
  )
}


export default DesktopThemePark